$eve_app_page_components_tab $eve_app_page_sb_page
	title \Tabs
	Head null
	body /
		<= Tab_catalog $eve_app_page_sb_catalog
			param \tab_variant
			spreads *
				group <= Group_page $eve_app_page_sb_page
					title \Tab Group
					body /
						<= Group_playground $eve_app_page_sb_playground
							component_name \Live_tab_group
							default_source \
								\Live_tab_group $eve_tab_group
								\	options *
								\		home \Home
								\		profile \Profile
								\		settings \Settings
								\		about \About
								\	value? \home
								\
				single <= Single_page $eve_app_page_sb_page
					title \Single Tab
					body /
						<= Single_playground $eve_app_page_sb_playground
							component_name \Live_tab
							default_source \
								\Live_tab $eve_tab
								\	label \Tab Label
								\	checked? true
								\

